// https://stackoverflow.com/a/2901298
const commas = (x) => {
    if (!x) return ''
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

const percentage = (value) => {
    if (typeof value === 'number') {
        const pValue = (value * 100).toString()
        return `${pValue.split('.')[0]}%`
    }
    return value
}

const money = (value) => {
    value = Math.round(value)
    return '$' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

const round = (value, precision = 1) => {
    if (typeof value === 'number') {
        const factor = Math.pow(10, precision)
        return Math.round(value * factor) / factor
    }
    return value
}

const movement = (value) => {
    let num = (value * 100).toFixed(1)
    if (num === 0) {
        return '0%'
    }
    num = `${num}%`
    if (value >= 0) {
        return `+${num}`
    }
    return num
}

const votePercent = (value, unopposedD, unopposedR, shift) => {
    // if (!value && value !== 0) return ''

    let perc = parseFloat(value).toFixed(1)

    if ((perc > 99 && perc < 100) || (perc === '100.0' && !shift)) {
        perc = '> 99.0'
    } else if ((perc > 0 && perc < 1) || (perc === '0.0' && !shift)) {
        perc = '< 1.0'
    }
    if ((unopposedD === 1 || unopposedR === 1) && shift) {
        perc = '0.0'
    }
    return perc + '%'
}

const winPerc = (v) => {
    let perc = v
    if (perc > 99) {
        perc = '> ' + 99
    } else if (perc < 1) {
        perc = '< ' + 1
    }
    return perc
}

export default {
    commas,
    money,
    percentage,
    round,
    movement,
    votePercent,
    winPerc
}
